var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"presentSections",staticClass:"presentSections"},[(_vm.screen >= 768)?_c('PresentSectionDesktop',{attrs:{"isInView":_vm.isInView}}):_vm._e(),(_vm.screen <= 767)?_c('PresentSectionMobile',{attrs:{"isInView":_vm.isInView}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }